import './VendorForm.css';
const VendorForm = ({ city }) => {
  // const formRef = useRef(null);
  // const widgetContainerRef = useRef(null);
  // const widgetIdRef = useRef(null);
  // const [ready, setReady] = useState(false);
  // const [submitting, setSubmitting] = useState(false);

  // // Load Google reCAPTCHA script once
  // useEffect(() => {
  //   const existing = document.getElementById('recaptcha-v2-invisible');
  //   if (existing) {
  //     if (window.grecaptcha) window.grecaptcha.ready(setupWidget);
  //     return;
  //   }
  //   const s = document.createElement('script');
  //   s.id = 'recaptcha-v2-invisible';
  //   s.src = 'https://www.google.com/recaptcha/api.js';
  //   s.async = true;
  //   s.defer = true;
  //   s.onload = () => {
  //     if (window.grecaptcha) window.grecaptcha.ready(setupWidget);
  //   };
  //   document.head.appendChild(s);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // // Render the invisible widget
  // const setupWidget = () => {
  //   if (!widgetContainerRef.current || !window.grecaptcha) return;
  //   if (widgetIdRef.current != null) return;
  //   const id = window.grecaptcha.render(widgetContainerRef.current, {
  //     sitekey: SITE_KEY,
  //     size: 'invisible',
  //     badge: 'bottomright',
  //     callback: onResolved,
  //   });
  //   widgetIdRef.current = id;
  //   setReady(true);
  // };

  // // Called when captcha is solved
  // const onResolved = async (token) => {
  //   if (!formRef.current) return;
  //   try {
  //     setSubmitting(true);
  //     const fd = new FormData(formRef.current);
  //     fd.set('g-recaptcha-response', token);

  //     const res = await fetch(ENDPOINT, { method: 'POST', body: fd });
  //     const result = await res.text();
  //     alert(result === 'success' ? 'Registered!' : 'Email failed: ' + result);
  //     if (result === 'success') formRef.current.reset();
  //   } catch (e) {
  //     console.error(e);
  //     alert('Could not submit form. Please try again.');
  //   } finally {
  //     setSubmitting(false);
  //     if (widgetIdRef.current != null && window.grecaptcha) {
  //       window.grecaptcha.reset(widgetIdRef.current);
  //     }
  //   }
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (!window.grecaptcha || widgetIdRef.current == null) {
  //     alert('reCAPTCHA not ready. Please try again.');
  //     return;
  //   }
  //   window.grecaptcha.execute(widgetIdRef.current);
  // };

  return (
    <section className="vendor-page">
      <div className="vendor-overlay" />

      <div className="form-container">
        <h2>Maplee Pop-Up Markets</h2>

        <div className="christmas-market-info">
          <p>
            <strong>
              Join Maplee’s growing community of Canadian vendors, makers, artists,
              small businesses, and local brands at our upcoming pop-up markets.
            </strong>
          </p>

          <p>
            Maplee pop-up events are designed to help local businesses connect with
            shoppers in high-traffic areas across Canada. Our markets give vendors
            the opportunity to showcase handmade products, fashion, beauty, food,
            home goods, art, accessories, gifts, and other unique Canadian-made items
            in a curated retail environment.
          </p>

          <p>
            Whether you are launching a new brand, testing a product, growing your
            customer base, or looking for in-person sales opportunities, Maplee
            pop-up markets provide an accessible way to build visibility and connect
            directly with customers.
          </p>

          <h3>Upcoming Vendor Opportunities</h3>

          <p>
            Select one of the available pop-up market locations below to learn more
            and submit your vendor application.
          </p>

          <div className="upcoming-buttons">
            <div className="upcoming-card">
              <a
                href="https://docs.google.com/forms/d/1k4S5NQMP0at_ZJPbF2721WlSBu9ST9nSAJ8Trus4dlw/edit"
                target="_blank"
                rel="noreferrer"
                className="upcoming-btn upcoming-btn-distillery"
                aria-label="Apply for the Distillery District pop-up event"
              />

              <div className="upcoming-card-text">
                <h3>Distillery District</h3>
                <p>May 16–18th</p>
              </div>
            </div>

            <div className="upcoming-card">
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSfqoxVkJICP-ygzbg-9GuNVmg4Fe5b_BrjJaYV7o7gafkmMpQ/viewform?usp=header"
                target="_blank"
                rel="noreferrer"
                className="upcoming-btn upcoming-btn-toronto"
                aria-label="Apply for the Toronto pop-up event"
              />

              <div className="upcoming-card-text">
                <h3>Toronto</h3>
                <p>May 30th, 31st & July 13th, 14th</p>
              </div>
            </div>
          </div>

          <h3>Why Join a Maplee Pop-Up Market?</h3>

          <p>
            <strong>Brand Exposure:</strong> Showcase your products to local
            shoppers, tourists, families, and customers actively looking to discover
            unique Canadian brands.
          </p>

          <p>
            <strong>In-Person Sales:</strong> Create meaningful customer
            interactions, explain your products directly, and build stronger trust
            with buyers.
          </p>

          <p>
            <strong>Product Testing:</strong> Test new collections, pricing,
            packaging, and product ideas while receiving real-time feedback from
            shoppers.
          </p>

          <p>
            <strong>Community Networking:</strong> Connect with other entrepreneurs,
            makers, creators, and small business owners in the Maplee vendor
            community.
          </p>

          <p>
            <strong>Low-Barrier Retail Opportunity:</strong> Experience the benefits
            of physical retail without committing to the cost of a permanent
            storefront.
          </p>

          <h3>Who Can Apply?</h3>

          <p>
            Maplee welcomes applications from Canadian small businesses, independent
            vendors, local makers, artists, designers, creators, and entrepreneurs.
            Vendor spaces may be limited by product category to keep each market
            balanced and curated.
          </p>

          <p>
            <strong>
              Choose your preferred pop-up location above and complete the vendor
              registration form to apply for an upcoming Maplee pop-up market.
            </strong>
          </p>

          <p>
            <em>
              ***Vendor spots are limited and may vary by city, date, and product
              category. Apply early to secure your space.
            </em>
          </p>
        </div>
      </div>
    </section>
  );
};

export default VendorForm;